import type { CSSProperties } from 'react';
import { cn } from '@/lib/utils';

const pillStyle: CSSProperties = {
  background: 'linear-gradient(135deg, #a855f7 0%, #9333ea 50%, #7e22ce 100%)',
  boxShadow:
    '0 0 12px rgba(168, 85, 247, 0.6), 0 2px 6px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -1px 0 rgba(0, 0, 0, 0.2)',
  border: '1.5px solid rgba(255, 255, 255, 0.4)',
};

const labelStyle: CSSProperties = {
  textShadow: '0 1px 2px rgba(0, 0, 0, 0.6)',
  letterSpacing: '0.8px',
};

const glossStyle: CSSProperties = {
  background: 'radial-gradient(circle at center, rgba(255, 255, 255, 0.4) 0%, transparent 70%)',
};

export interface NewSidebarBadgeProps {
  className?: string;
}

export function NewSidebarBadge({ className }: NewSidebarBadgeProps) {
  return (
    <div className={cn('pointer-events-none z-10 animate-pulse', className)}>
      <div
        className="relative flex items-center justify-center rounded-full px-2 py-0.5"
        style={pillStyle}
      >
        <span
          className="relative z-10 text-[9px] font-extrabold uppercase leading-none tracking-wider text-white"
          style={labelStyle}
        >
          NEW
        </span>
        <div className="absolute inset-0 rounded-full opacity-30" style={glossStyle} />
      </div>
    </div>
  );
}
